import React from 'react';
import ReactDOM from 'react-dom';

import { createStore, combineReducers } from 'redux';
import { Provider } from 'react-redux';

import {
  ReactReduxFirebaseProvider,
  firebaseReducer
} from 'react-redux-firebase';

import { 
  createFirestoreInstance, 
  firestoreReducer,
} from 'redux-firestore';

import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import "firebase/messaging";
import 'firebase/storage';

import "leaflet/dist/leaflet.css";

import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';

import { firebaseConfig } from '@/constants/firebase';

// react-redux-firebase config
const rrfConfig = {
  userProfile: 'users',
  useFirestoreForProfile: true,
}

// Initialize firebase instance and other services
firebase.initializeApp(firebaseConfig);
firebase.firestore();
export const cloudFunctions = firebase.app().functions("europe-west1");
firebase.analytics();

// Check if messaging is available
let useMessaging = false;
let messaging;

if (firebase.messaging.isSupported()) {
  messaging = firebase.messaging();
}

// Add firebase to reducers
const rootReducer = combineReducers({
  firebase: firebaseReducer,
  firestore: firestoreReducer,
})

// Create store with reducers and initial state
const initialState = {};
const store = createStore(rootReducer, initialState);

let rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance,
};

rrfProps = useMessaging ? {...rrfProps, messaging} : rrfProps;

function RenderApp() {
  return (
    <Provider store={store}>
      <ReactReduxFirebaseProvider {...rrfProps}>
        <App />
      </ReactReduxFirebaseProvider>
    </Provider>
  )
}

ReactDOM.render(<RenderApp />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();

if (firebase.messaging.isSupported) {
  serviceWorkerRegistration.registerMessaging();
};

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
